import Dashboard from '~/views/Manage/Manage/Dashboard';
import DailyPlan from '~/views/Manage/Manage/DailyPlan';
import DailyCheckout from '~/views/Manage/Manage/DailyCheckout';
import DailyCheckoutDetail from '~/views/Manage/Manage/DailyCheckoutDetail';
import TrainingFeed from '~/views/Manage/Manage/TrainingFeed';
import ScorecardList from '~/views/Manage/Manage/ScorecardList';
import ScorecardDetail from '~/views/Manage/Manage/ScorecardDetail';
import TasksProjects from '~/views/Manage/Manage/TasksProjects';
import Assignments from '~/views/Manage/Reports/Assignments';
import CareerDetail from '~/views/Manage/Reports/CareerDetail';
import CareerEdit from '~/views/Manage/Reports/CareerEdit';
import CareerList from '~/views/Manage/Reports/CareerList';
import Engagement from '~/views/Manage/Reports/Engagement';
import ManagerDashboard from '~/views/Manage/Reports/ManagerDashboard';
import CompanyReview from '~/views/Manage/Reports/CompanyPerformance';
import IndividualReview from '~/views/Manage/Reports/IndividualPerformance';
import CompanyTask from '~/views/Manage/Reports/CompanyTask';
import IndividualTask from '~/views/Manage/Reports/IndividualTask';
import CompanyTraining from '~/views/Manage/Reports/CompanyTraining';
import IndividualTraining from '~/views/Manage/Reports/IndividualTraining';
import CompanyTrainingSchedule from '~/views/Manage/Reports/CompanyTrainingSchedule';
import IndividualTrainingSchedule from '~/views/Manage/Reports/IndividualTrainingSchedule';
import AddTrainingSchedule from '~/views/Manage/Reports/AddTrainingSchedule';
import Certifications from '~/views/Manage/Reports/Certifications';
import CertificationDetail from '~/views/Manage/Reports/CertificationDetail';
import CertificationEdit from '~/views/Manage/Reports/CertificationEdit';
import Report from '~/views/Manage/Reports/Report';
import NewHireOrientation from '~/views/Manage/Reports/NewHireOrientation';
import Birthday from '~/views/Manage/Reports/Birthday';
import Anniversary from '~/views/Manage/Reports/Anniversary';
import SignatureList from '~/views/Manage/Reports/SignatureList';
import CompanyQuota from '~/views/Manage/Reports/CompanyQuota';
import TrainingCompetency from '~/views/Manage/Reports/TrainingCompetency';
import IndividualQuota from '~/views/Manage/Reports/IndividualQuota';
import QuotaDetail from '~/views/Manage/Reports/QuotaDetail';
import SaveActuals from '~/views/Manage/Reports/SaveActuals';
import TrainingTrack from '~/views/Manage/Reports/TrainingTrack';
import TrainingTrackDetail from '~/views/Manage/Reports/TrainingTrackDetail';
import ActivityReport from '~/views/Manage/Reports/ActivityReport';
import CheckoutReport from '~/views/Manage/Reports/CheckoutReport';
import CheckoutReportIndividual from '~/views/Manage/Reports/CheckoutReportIndividual';
import AddCompany from '~/views/Manage/Records/AddCompany';
import AddEmployee from '~/views/Manage/Records/AddEmployee';

import DocumentList from '~/views/Develop/Library/DocumentList';
import DocumentDetail from '~/views/Develop/Library/DocumentDetail';
import DocumentEdit from '~/views/Develop/Library/DocumentEdit';
import ProgramList from '~/views/Develop/Library/ProgramList';
import ProgramAdd from '~/views/Develop/Library/ProgramAdd';
import ProgramDetail from '~/views/Develop/Library/ProgramDetail';
import ProgramEdit from '~/views/Develop/Library/ProgramEdit';
import ToDoList from '~/views/Develop/Library/ToDoList';
import ToDoAdd from '~/views/Develop/Library/ToDoAdd';
import ToDoDetail from '~/views/Develop/Library/ToDoDetail';
import ToDoEdit from '~/views/Develop/Library/ToDoEdit';
import TrainingAdd from '~/views/Develop/Library/TrainingAdd';
import TrainingList from '~/views/Develop/Library/TrainingList';
import TrainingDetail from '~/views/Develop/Library/TrainingDetail';
import TrainingEdit from '~/views/Develop/Library/TrainingEdit';
import Quotas from '~/views/Develop/Library/QuotaList';
import ScoreCards from '~/views/Develop/Library/ScoreCards';

import CommunityHome from '~/views/Community/Community/Home';
import Profile from '~/views/Community/Community/Profile';
import Blogs from '~/views/Community/Community/Blogs';
import Forums from '~/views/Community/Community/Forums';
import DepartmentFeed from '~/views/Community/Community/Forums/DepartmentFeed';
import IndividualTopic from '~/views/Community/Community/Forums/IndividualTopic';
import DepartmentHome from '~/views/Community/Departments/Home';
import Network from '~/views/Community/Community/Network';

import VendorHome from '~/views/VendorRatings/Home';
import ByCategory from '~/views/VendorRatings/ByCategory';
import ByCategoryDetail from '~/views/VendorRatings/ByCategoryDetail';
import ByCompany from '~/views/VendorRatings/ByCompany';
import ByName from '~/views/VendorRatings/ByName';
import RateVendor from '~/views/VendorRatings/RateVendor';
import AddVendor from '~/views/VendorRatings/AddVendor';
import BuyerGuide from '~/views/VendorRatings/BuyerGuide';
import DealerSatisfactionAward from '~/views/VendorRatings/DealerSatisfactionAward';
import FAQ from '~/views/VendorRatings/FAQ';
import VendorSearch from '~/views/VendorRatings/VendorSearch';
import CompanyMgt from '~/views/VendorRatings/CompanyMgt';
import ContentMgt from '~/views/VendorRatings/ContentMgt';
import FeaturedContent from '~/views/VendorRatings/FeaturedContent';
import UserMgt from '~/views/VendorRatings/UserMgt';
import VRCategoryMgt from '~/views/VendorRatings/VRCategoryMgt';
import VRRatingMgt from '~/views/VendorRatings/VRRatingMgt';

import AnlLanding from '~/views/Analytics/Landing';
import EvtLanding from '~/views/Events/Landing';

import Slug from '~/views/Slug';

const privateRoutes = [
    //{ path: '/hcm/dashboard', component: Dashboard },
    //{ path: '/hcm/daily-plan', component: DailyPlan },
    //{ path: '/hcm/daily-checkout', component: DailyCheckout },
    //{ path: '/hcm/daily-checkout/:id', component: DailyCheckoutDetail },
    //{ path: '/hcm/tasks-projects', component: TasksProjects },
    //{ path: '/hcm/training-feed', component: TrainingFeed },
    //{ path: '/hcm/performance-reviews', component: ScorecardList },
    //{ path: '/hcm/performance-reviews/:id', component: ScorecardDetail },
    //{ path: '/hcm/reports', component: Report },
    //{ path: '/hcm/report-assignments', component: Assignments },
    //{ path: '/hcm/report-careers', component: CareerList },
    //{ path: '/hcm/report-careers/:type/:id/view', component: CareerDetail },
    //{ path: '/hcm/report-careers/:type/:id/edit', component: CareerEdit },
    //{ path: '/hcm/report-certifications', component: Certifications },
    //{ path: '/hcm/report-certifications/:userId/:id/view', component: CertificationDetail },
    //{ path: '/hcm/report-certifications/:userId/:id/edit', component: CertificationEdit },
    //{ path: '/hcm/report-engagement', component: Engagement },
    //{ path: '/hcm/report-manager-dashboard', component: ManagerDashboard },
    //{ path: '/hcm/report-performance', component: CompanyReview },
    //{ path: '/hcm/report-performance/:id', component: IndividualReview },
    //{ path: '/hcm/report-signature', component: SignatureList },
    //{ path: '/hcm/report-task', component: CompanyTask },
    //{ path: '/hcm/report-task/:id', component: IndividualTask },
    //{ path: '/hcm/report-training', component: CompanyTraining },
    //{ path: '/hcm/report-training/:companyId/:userId', component: IndividualTraining },
    //{ path: '/hcm/report-training-schedule', component: CompanyTrainingSchedule },
    //{ path: '/hcm/report-training-schedule/:id', component: IndividualTrainingSchedule },
    //{ path: '/hcm/report-add-training-schedule/:id', component: AddTrainingSchedule },
    //{ path: '/hcm/report-quota', component: CompanyQuota },
    //{ path: '/hcm/report-quota/:id', component: IndividualQuota },
    //{ path: '/hcm/report-quota-employee/:id/:tab', component: QuotaDetail },
    //{ path: '/hcm/report-anniversary', component: Anniversary },
    //{ path: '/hcm/report-birthday', component: Birthday },
    //{ path: '/hcm/report-new-hire-orientation', component: NewHireOrientation },
    //{ path: '/hcm/report-training-competency', component: TrainingCompetency },
    //{ path: '/hcm/report-save-actuals', component: SaveActuals },
    //{ path: '/hcm/report-training-track', component: TrainingTrack },
    //{ path: '/hcm/report-training-track/:id', component: TrainingTrackDetail },
    //{ path: '/hcm/report-activity', component: ActivityReport },
    //{ path: '/hcm/report-checkout', component: CheckoutReport },
    //{ path: '/hcm/report-checkout/:idParam', component: CheckoutReportIndividual },
    //{ path: '/hcm/report-checkout/individual', component: CheckoutReportIndividual },
    //{ path: '/hcm/record-add-employee', component: AddEmployee },
    //{ path: '/hcm/record-add-company', component: AddCompany },

    //{ path: '/library/documents', component: DocumentList },
    //{ path: '/library/documents/:activeTab/:id/view', component: DocumentDetail },
    //{ path: '/library/documents/:activeTab/:id/edit', component: DocumentEdit },
    { path: '/library/programs', component: ProgramList },
    { path: '/library/career/:activeTab', component: ProgramList },
    //{ path: '/library/certification/:activeTab', component: ProgramList },
    { path: '/library/programs/:activeTab/new', component: ProgramAdd },
    { path: '/library/programs/:activeTab/:id/view', component: ProgramDetail },
    { path: '/library/programs/:activeTab/:id/edit', component: ProgramEdit },
    // { path: '/library/questionnaires', component: TrainingList },
    { path: '/library/to-do', component: ToDoList },
    { path: '/library/habits', component: ToDoList },
    { path: '/library/to-do/:activeTab/new', component: ToDoAdd },
    { path: '/library/to-do/:activeTab/:id/view', component: ToDoDetail },
    { path: '/library/to-do/:activeTab/:id/edit', component: ToDoEdit },
    { path: '/library/training', component: TrainingList },
    { path: '/library/training/:activeTab/new', component: TrainingAdd },
    { path: '/library/training/:activeTab/:id/view', component: TrainingDetail },
    { path: '/library/training/:activeTab/:id/edit', component: TrainingEdit },
    //{ path: '/library/report-assignments', component: Assignments },
    //{ path: '/library/report-careers', component: CareerList },
    //{ path: '/library/report-certifications', component: Certifications },
    //{ path: '/library/report-engagement', component: Engagement },
    //{ path: '/library/report-performance', component: CompanyReview },
    //{ path: '/library/report-task', component: CompanyTask },
    //{ path: '/library/report-training', component: CompanyTraining },
    //{ path: '/library/report-training-schedule', component: CompanyTrainingSchedule },
    { path: '/library/quotas', component: Quotas },
    { path: '/library/scorecards', component: ScoreCards },
    { path: '/library/:activeTab/:id/view', component: ToDoDetail },
    { path: '/library/:activeTab/:id/edit', component: ToDoEdit },
    { path: '/library/:activeTab/new', component: ToDoAdd },

    //{ path: '/community/home', component: CommunityHome },
    //{ path: '/community/profile/:activeTab/*', component: Profile },
    //{ path: '/community/blogs', component: Blogs },
    //{ path: '/forums', component: Forums },
    //{ path: '/community/forums/:topicId/:departId', component: IndividualTopic },
    //{ path: '/community/network', component: Network },
    //{ path: '/community/departments/:department', component: DepartmentHome },
    //{ path: '/community/forum-department-feed/:departId', component: DepartmentFeed },

    //{ path: '/vendor-ratings/home', component: VendorHome },
    //{ path: '/vendor-ratings/by-category', component: ByCategory },
    //{ path: '/vendor-ratings/by-category/:id', component: ByCategoryDetail },
    //{ path: '/vendor-ratings/by-company', component: ByCompany },
    //{ path: '/vendor-ratings/dealer-satisfaction-award', component: DealerSatisfactionAward },
    //{ path: '/vendor-ratings/buyer-guide', component: BuyerGuide },
    // { path: '/vendor-ratings/by-name', component: ByName },
    // { path: '/vendor-ratings/rate-vendor', component: RateVendor },
    // { path: '/vendor-ratings/add-vendor', component: AddVendor },
    //{ path: '/vendor-ratings/faq', component: FAQ },
    //{ path: '/vendor-ratings/search', component: VendorSearch },
    //{ path: '/vendor-ratings/company-mgt', component: CompanyMgt },
    //{ path: '/vendor-ratings/content-mgt', component: ContentMgt },
    //{ path: '/vendor-ratings/featured-content', component: FeaturedContent },
    //{ path: '/vendor-ratings/user-mgt', component: UserMgt },
    //{ path: '/vendor-ratings/vr-category-mgt', component: VRCategoryMgt },
    //{ path: '/vendor-ratings/vr-rating-mgt', component: VRRatingMgt },

    //{ path: '/forums/:category', component: Forums },
    //{ path: '/forums/:category/:topic', component: Forums },
    //{ path: '/business', component: Slug },

    //{ path: '/analytics', component: AnlLanding },
    //{ path: '/events', component: EvtLanding },

    { from: '/hcm', to: '/library/training' },
    { from: '/library', to: '/library/training' },
    { from: '/community', to: '/community/home' },
    { from: '/vendor-ratings', to: '/vendor-ratings/home' },

    // Dynamic routes for user and business profiles - these should be at the end to avoid conflicts
    //{ path: '/:entity', component: Slug },
    //{ path: '/:entity/:product/*', component: Slug },
    //{ path: '/:entity/blog', component: Slug },
    //{ path: '/:entity/blog/:post', component: Slug },
];

export default privateRoutes;
